import React from "react";
import { useStyle } from "../context/StyleContext";

const PrintTemplate = React.forwardRef(({ photos, theme }, ref) => {
  const vintageFilter =
    "sepia(0.5) contrast(1.2) brightness(0.9) saturate(0.6) hue-rotate(-20deg)";
  const styles = useStyle();
  const name = localStorage.getItem("photobooth_boothName");

  // console.log("Booth Name from localStorage:", name);
  // console.log("Booth Theme from localStorage:", bgTheme);
  // console.log("Booth theme from transfer:", theme);
  return (
    <div
      ref={ref}
      style={{
        marginTop: "0.02in", // Offset for top margin
        marginLeft: "0.07in", // Offset for left margin
        marginRight: "0.05in", // Offset for right margin
        width: "calc(100% - 0.12in)", // Adjust width to account for left and right margins
        height: "calc(100vh - 0.02in)", // Adjust height to account for top margin
        padding: "0.3cm", // Padding around the border (equivalent to 0.3cm)
        boxSizing: "border-box",
        display: "grid",
        gridTemplateColumns: "1fr 0.6cm 1fr", // Middle space of exactly 0.6cm
        gridTemplateRows: "1fr 1fr 1fr auto",
        gap: "10px 0", // Vertical gap of 10px, no horizontal gap
        alignItems: "center",
        justifyItems: "center",
        // background: theme === "dark" ? "black" : "white",
        background:
          theme === "dark"
            ? styles.blackStripBackgroundColor
            : styles.whiteStripBackgroundColor,
        // color: theme === "dark" ? "white" : "black",
        color: theme === "dark" ? "#fe67ac" : "black",
        pageBreakInside: "avoid",
        overflow: "hidden", // Prevent overflow to the next page
      }}
    >
      {photos.slice(0, 3).map((photo, index) => (
        <React.Fragment key={index}>
          <div style={{ height: "100%" }}>
            <img
              src={photo}
              alt={`Photo ${index + 1}`}
              style={{
                width: "100%", // Fit within the container
                height: "100%", // Fit within the container
                objectFit: "cover",
                borderRadius: "0", // No rounded edges
                // filter: filter === "vintage" ? vintageFilter : "none",
              }}
            />
          </div>
          <div style={{ width: "0.6cm", height: "100%" }}></div>{" "}
          {/* Middle space of exactly 0.6cm */}
          <div style={{ height: "100%" }}>
            <img
              src={photo}
              alt={`Photo ${index + 1}`}
              style={{
                width: "100%", // Fit within the container
                height: "100%", // Fit within the container
                objectFit: "cover",
                borderRadius: "0", // No rounded edges
                // filter: filter === "vintage" ? vintageFilter : "none",
              }}
            />
          </div>
        </React.Fragment>
      ))}
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          fontWeight: "bold",
          fontSize: "1.2em",
          letterSpacing: "2px",
          padding: "0px", // Reduced padding
          width: "100%",
          gridColumn: "span 3", // Span across all three columns
          marginTop: "5px", // Added marginTop for better spacing
          // background: theme === "dark" ? "black" : "white",
          background:
            theme === "dark"
              ? styles.blackStripBackgroundColor
              : styles.whiteStripBackgroundColor,
          overflow: "hidden", // Ensure it fits within the page
        }}
      >
        <img
          src={
            name === "Kwave"
              ? "./KWave.png"
              : theme === "dark"
              ? `.${styles.printLogo_Black}`
              : `.${styles.printLogo_White}`
          }
          alt="Restaurant Logo"
          style={{
            width: "100px", // Original width
            height: "100px", // Original height
            objectFit: "contain", // Ensures the logo scales proportionally
            margin: "0 5px", // Maintains spacing between images
            transform: `scale(${styles.imageScale})`, // Scales the logo to 120% of its original size
            transformOrigin: "center", // Keeps the scaling centered
            marginBottom: "10px",
          }}
        />
        {console.log(styles.restaurantLogo)}
        {console.log(styles.printLogo_White, styles.printLogo_Black)}
        <img
          src={
            name === "Kwave"
              ? "./KWave.png"
              : theme === "dark"
              ? `.${styles.printLogo_Black}`
              : `.${styles.printLogo_White}`
          }
          alt="Restaurant Logo"
          style={{
            width: "100px",
            height: "100px",
            objectFit: "contain",
            margin: "0 5px",
            transform: `scale(${styles.imageScale})`,
            transformOrigin: "center",
            marginBottom: "10px",
          }}
        />
      </div>
    </div>
  );
});

export default PrintTemplate;

// <img
// src={name === "Kwave" ? "./KWave.png" : `.${styles.restaurantLogo}`}
// style={{
//   width: "100px",
//   height: "100px",
//   margin: "0 5px", // Reduced margin for spacing between images
// }}
// alt="Logo"
// />
// {console.log(styles.restaurantLogo)}
// <img
// src={
//   name === "Kwave" ? "./memories.png" : `.${styles.restaurantLogo}`
// }
// style={{
//   width: "100px",
//   height: "100px",
//   margin: "0 5px", // Reduced margin for spacing between images
// }}
// alt="Logo"
// />
